import { IonButton, IonIcon, IonInput, useIonRouter } from "@ionic/react";
import imageCompression from "browser-image-compression";
// import EmojiPicker from "emoji-picker-react";

import {
  barChartOutline,
  imageOutline,
  pieChartOutline,
  videocamOutline,
} from "ionicons/icons";
import { useEffect, useRef, useState, useId } from "react";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import TextareaAutosize from "react-textarea-autosize";
import Avatar from "../avatar/Avatar";
import PostPoll from "./PostPollInput";
import PostRace from "./PostRaceInput";

import ExamImageSrc from "../../assets/images/quizLoon.jpg";
import SelectExam from "./SelectExam";
import { SERVER_URL } from "../../api/client";
import axios from "axios";
// const tenorApiKey = "AIzaSyCQSahDEPoZq1vS1EzHgGjp64tyT3fIJCY";

const styles = {
  media: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    // marginTop: "12px",
  },
  previewWrapper: {
    position: "relative",
    width: "150px",
    height: "150px",
    paddingBottom: "10px",
  },
  preview: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
  },
  closeIcon: {
    position: "absolute",
    top: "6px",
    right: "6px",
    background: "rgba(0, 0, 0, 0.5)",
    color: "white",
    borderRadius: "50%",
    padding: "4px",
    cursor: "pointer",
    zIndex: 1,
  },
};

const VideoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    color="inherit"
    fill="currentColor"
  >
    <path d="m380-340 280-180-280-180v360Zm-60 220v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z" />
  </svg>
);

export const AiIcon = ({ className }) => (
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    color="inherit"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    height={30}
    stroke-width="2"
    style={{
      marginBottom: "4px",
    }}
    className={className}
  >
    <path d="M18.25,18.0882l9.9756,18.2505c.9561,1.7492,1.1131,3.1695-.8831,3.1726L6.3775,39.544c-1.35.0021-2.43-.8761-1.57-2.453L15.1757,18.0882C16.3223,15.9867,17.7365,17.1484,18.25,18.0882Z" />
    <path d="M25.0422,30.5142l6.5851-8.8282L43.5,39.4459l-16.1573.0654" />
    <path d="M16.5821,21.8168l-4.1865,9.3215,8.7.0654Z" />
    <path d="M8.8635,39.54,10.27,35.6846h12.494l2.0283,3.8307" />
    <path d="M31.6273,21.686V39.4942" />
    <path d="M35,26.731V39.48" />
    <circle cx="32.1507" cy="12.5607" r="4.1047" />
  </svg>
);

const ProgressBar = () => {
  return (
    <div className="progress-bar-container">
      <div className="progress-bar" />
    </div>
  );
};

const KeyboardAwareDiv = ({
  children,
  className = "",
  style = {},
  ...props
}) => {
  const [height, setHeight] = useState("100dvh");
  const containerRef = useRef(null);
  const lastVisualHeight = useRef(0);

  const headerSize = 50;

  useEffect(() => {
    const calculateHeight = () => {
      if (window.visualViewport) {
        const visualHeight = window.visualViewport.height;

        if (Math.abs(visualHeight - lastVisualHeight.current) > 1) {
          lastVisualHeight.current = visualHeight;
          return `${visualHeight - headerSize}px`;
        }
      }

      if (typeof window.innerHeight === "number") {
        return `${window.innerHeight - headerSize}px`;
      }

      return "100dvh";
    };

    const updateHeight = () => {
      const newHeight = calculateHeight();
      setHeight(newHeight);
    };

    // Set initial height
    updateHeight();

    // Add event listeners
    const events = ["resize", "orientationchange"];
    const visualViewport = window.visualViewport;

    if (visualViewport) {
      visualViewport.addEventListener("resize", updateHeight);
    }

    events.forEach((event) => {
      window.addEventListener(event, updateHeight);
    });

    // Cleanup function
    return () => {
      if (visualViewport) {
        visualViewport.removeEventListener("resize", updateHeight);
      }

      events.forEach((event) => {
        window.removeEventListener(event, updateHeight);
      });
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        height,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

const PostForm = ({
  onlyVideo,
  onSubmit,
  placeholder,
  buttonText,
  isPollPost,
  isRacePost,
  prependValue,
  isReply,
  exam,
  handleExamChange,
}) => {
  const { t } = useTranslation();
  const bodyRef = useRef();
  const subjectRef = useRef();
  const fileInputRef = useRef(null);
  const inputId = useId();

  const [previews, setPreviews] = useState([]);
  // const [gif, setGif] = useState(null);
  // const [emojiPickerOpen, setEmojiPickerOpen] = useState(false);
  // const [gifPickerOpen, setGifPickerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPoll, setShowPoll] = useState(isPollPost || false);
  const [showRace, setShowRace] = useState(isRacePost || false);
  const [poll, setPoll] = useState(null);
  const [race, setRace] = useState(null);
  const [mediaFiles, setMediaFiles] = useState();
  const [processingImageLoading, setProcessingImageLoading] = useState(false);
  const [error, setError] = useState(null);
  const [postType, setPostType] = useState("Post");
  const [aiPrompt, setAiPrompt] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  // const { isCanadian } = useSelector(
  //   (state) => state.currentProfile.data || {}
  // );

  const router = useIonRouter();

  const { username, avatar, province, isAdmin } = useSelector(
    (state) => state.currentProfile.data,
  );

  useEffect(() => {
    if (prependValue) {
      setPostType("Discussion");
    }
  }, [prependValue]);

  useEffect(() => {
    if (!isReply) {
      if (postType === "Discussion" && subjectRef.current) {
        bodyRef.current?.blur();
        subjectRef.current.focus();
      } else if (postType === "Post" && bodyRef.current) {
        subjectRef.current?.blur();
        bodyRef.current.focus();
      }
    }
  }, [postType, isReply]);

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    const formData = new FormData(e.target);
    if (postType !== "Discussion") {
      formData.delete("subject");
    }

    if (prependValue) {
      const currentBody = formData.get("body") || "";
      formData.set("body", prependValue + " " + currentBody);
    }

    if (showPoll && poll && poll.options?.length > 0) {
      const options = poll.options.filter((opt) => opt.trim());
      formData.append("poll", JSON.stringify({ options }));
    } else if (showRace && race && race.data?.length > 0) {
      const data = race.data;
      formData.append(
        "race",
        JSON.stringify({
          data: data.flatMap((group) =>
            group.entries.map((entry) => ({
              date: group.date,
              name: entry.name,
              value: entry.value.replace(",", ""),
            })),
          ),
        }),
      );
    } else if (mediaFiles && mediaFiles.length > 0) {
      for (let i = 0; i < mediaFiles.length && i < 4; i++) {
        formData.append("media", mediaFiles[i]);
      }
      // } else if (gif) {
      // formData.append("gifUrl", gif.url);
    } else if (exam) {
      formData.append("exam", exam);
    } else {
      // body length must be greater than 0
      if (formData.get("body").trim().length === 0) {
        setError("Post cannot be empty");
        setLoading(false);
        return;
      }
    }

    onSubmit(formData).then(() => {
      setLoading(false);
    }); // dispatch event and call API
    e.target.reset();
    clearMediaInput();
    // setGif(null);
    setShowPoll(false);
    setPoll(null);
    setShowRace(false);
    setRace(null);
    setMediaFiles(null);
  };
  // const handleGenerateAiPost = async () => {
  //   if (!aiPrompt.trim()) {
  //     setError("Please enter an idea for the AI post.");
  //     return;
  //   }

  //   try {
  //     setAiLoading(true);
  //     setError(null);

  //     const res = await axios.post(
  //       `${SERVER_URL}/post-ai`,
  //       {
  //         idea: aiPrompt,
  //         tone: "friendly",
  //         type: postType,
  //       },
  //       {
  //         withCredentials: true,
  //       },
  //     );

  //     const data = res.data;

  //     if (bodyRef.current) {
  //       bodyRef.current.value = data.text || data.post || data.result || "";
  //       bodyRef.current.focus();
  //     }
  //   } catch (err) {
  //     setError(
  //       err?.response?.data?.error ||
  //         err.message ||
  //         "AI post generation failed.",
  //     );
  //   } finally {
  //     setAiLoading(false);
  //   }
  // };
  // const handleMediaChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   const previewUrls = files.map((file) => ({
  //     url: URL.createObjectURL(file),
  //     type: file.type,
  //   }));
  //   setPreviews(previewUrls);
  //   setGif(null);
  // };

  const handleMediaChange = async (e) => {
    const files = Array.from(e.target.files);
    const compressedFiles = [];
    const previews = [];

    // Clear any previous errors
    setError(null);

    // Separate videos and images
    const videos = files.filter((file) => file.type.startsWith("video/"));
    const images = files.filter((file) => file.type.startsWith("image/"));

    // Validate media rules: 1 video max OR 4 images max, not mixed
    if (videos.length > 1) {
      setError("Maximum 1 video allowed per post.");
      e.target.value = "";
      return;
    }

    if (images.length > 4) {
      setError("Maximum 4 images allowed per post.");
      e.target.value = "";
      return;
    }

    if (videos.length > 0 && images.length > 0) {
      setError("Cannot mix videos and images in the same post.");
      e.target.value = "";
      return;
    }

    // Updated file size limits
    const MAX_IMAGE_SIZE = 15 * 1024 * 1024; // 15MB for images
    const MAX_VIDEO_SIZE = 60 * 1024 * 1024; // 60MB for videos (will be compressed on backend)

    for (const file of files) {
      const isVideo = file.type.startsWith("video/");
      const maxSize = isVideo ? MAX_VIDEO_SIZE : MAX_IMAGE_SIZE;
      const fileType = isVideo ? "video" : "image";

      if (file.size > maxSize) {
        setError(
          `File "${file.name}" exceeds the maximum ${fileType} size limit of ${
            maxSize / (1024 * 1024)
          }MB.`,
        );
        e.target.value = "";
        return;
      }
    }

    setProcessingImageLoading(true);

    // try {
    //   for (const file of files) {
    //     if (file.type.startsWith("image/")) {
    //       // const options = {
    //       //   maxSizeMB: 0.1,            // ~100KB per image (safe balance of size + quality)
    //       //   maxWidthOrHeight: 400,     // still small but crisp for feeds/avatars
    //       //   quality: 0.75,             // better clarity (0.7–0.8 is sweet spot)
    //       //   fileType: "image/webp",    // efficient format
    //       //   useWebWorker: true,
    //       // };
    //       // const options = {
    //       //   maxSizeMB: 0.8,
    //       //   maxWidthOrHeight: 1200,
    //       //   initialQuality: 0.9,
    //       //   quality: 0.88,
    //       //   fileType: "image/webp",
    //       //   useWebWorker: true,
    //       // };
    //       // const options = {
    //       //   maxSizeMB: 0.8,
    //       //   maxWidthOrHeight: 1200,
    //       //   initialQuality: 0.9,
    //       //   quality: 0.88,
    //       //   fileType: "image/webp",
    //       //   useWebWorker: true,
    //       // };
    //       const options = {
    //         maxSizeMB: 1,
    //         maxWidthOrHeight: 1200,
    //         initialQuality: 0.9,
    //         quality: 0.88,
    //         fileType: "image/webp",
    //         useWebWorker: true,
    //       };
    //       const compressed = await imageCompression(file, options);

    //       compressedFiles.push(
    //         new File([compressed], file.name, { type: "image/webp" }),
    //       );

    //       // Generate preview URL for feed display
    //       previews.push({
    //         url: URL.createObjectURL(compressed),
    //         type: file.type,
    //       });
    //     } else {
    //       // Keep videos as-is
    //       compressedFiles.push(file);
    //       previews.push({
    //         url: URL.createObjectURL(file),
    //         type: file.type,
    //       });
    //     }
    //   }

    try {
      for (const file of files) {
        if (file.type.startsWith("image/")) {
          const options = {
            maxSizeMB: 1.2,
            maxWidthOrHeight: 1600,
            initialQuality: 0.95,
            quality: 0.93,
            fileType: "image/webp",
            useWebWorker: true,
          };

          const compressed = await imageCompression(file, options);

          const webpName = file.name.replace(/\.[^.]+$/, ".webp");
          const compressedFile = new File([compressed], webpName, {
            type: "image/webp",
          });

          compressedFiles.push(compressedFile);

          // Generate preview URL for feed display
          previews.push({
            url: URL.createObjectURL(compressedFile),
            type: "image/webp",
          });
        } else {
          // Keep videos as-is
          compressedFiles.push(file);
          previews.push({
            url: URL.createObjectURL(file),
            type: file.type,
          });
        }
      }

      setPreviews(previews);
      setMediaFiles(compressedFiles); // store for later upload
      // setGif(null);
      setProcessingImageLoading(false);
    } catch (err) {
      console.error("Media processing error:", err);
      setProcessingImageLoading(false);
    }
  };

  const clearMediaInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setPreviews([]);
    setMediaFiles(null);
  };

  // const handleGifClick = (gif) => {
  //   setGif(gif);
  //   clearMediaInput();
  //   setGifPickerOpen(false);
  // };

  const toggleShowPoll = () => {
    setShowPoll(!showPoll);
    setShowRace(false);
  };
  const toggleShowRace = () => {
    setShowRace(!showRace);
    setShowPoll(false);
  };

  // const Container = isReply ? "div" : KeyboardAwareDiv;
  const Container = isReply ? "div" : KeyboardAwareDiv;
  return (
    <>
      <Container
        className={`poppins post-form display-flex flex-col ${
          !isReply && "post-form-full-screen padding"
        }`}
        style={{
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <form
          className="post-form__form"
          onSubmit={handleSubmit}
          autoComplete="off"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          {!isReply ? (
            <div className="display-flex align-items-c justify-content-sb">
              <button
                type="button"
                className="close-post-button"
                onClick={() => router.push("/")}
              >
                Cancel
              </button>
              <IonButton
                type="submit"
                size="small"
                disabled={loading}
                // disabled={loading || !isCanadian}
                className="c-button c-button-inverse ion-button-small poetsen"
                expand="block"
                fill="clear"
              >
                {loading ? t("postForm.posting") : t("postForm.post")}
              </IonButton>
            </div>
          ) : (
            <div className="flex justify-content-fe">
              <IonButton
                type="submit"
                size="small"
                disabled={loading}
                className="c-button c-button-inverse ion-button-small poetsen"
                expand="block"
                fill="clear"
              >
                {loading ? t("postForm.replying") : t("postForm.reply")}
              </IonButton>
            </div>
          )}

          {!isReply && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto 1fr",
                alignItems: "center",
                marginBottom: "8px",
                marginTop: "8px",
              }}
            >
              <div style={{ display: "flex" }}>
                <Avatar
                  username={username}
                  avatar={avatar}
                  province={province}
                  size="small"
                  isOfficial={isAdmin}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  background: "#f0f0f0",
                  borderRadius: "20px",
                }}
              >
                <div
                  onClick={() => setPostType("Post")}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    background: postType === "Post" ? "white" : "transparent",
                    color: postType === "Post" ? "var(--main-color)" : "",
                    boxShadow:
                      postType === "Post"
                        ? "0 2px 4px rgba(0,0,0,0.1)"
                        : "none",
                    fontWeight: postType === "Post" ? "bold" : "normal",
                  }}
                >
                  Posts
                </div>
                <div
                  onClick={() => setPostType("Discussion")}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    background:
                      postType === "Discussion" ? "white" : "transparent",
                    color: postType === "Discussion" ? "var(--main-color)" : "",
                    boxShadow:
                      postType === "Discussion"
                        ? "0 2px 4px rgba(0,0,0,0.1)"
                        : "none",
                    fontWeight: postType === "Discussion" ? "bold" : "normal",
                  }}
                >
                  {t("postForm.discussion")}
                </div>
              </div>
              <div></div>
            </div>
          )}

          <div
            className="display-flex align-items-fs flex-1"
            style={{ minHeight: 0 }}
          >
            {isReply && (
              <div className="post-form__img display-flex justify-content-c align-items-c">
                <Avatar
                  username={username}
                  avatar={avatar}
                  province={province}
                  size="small"
                  isOfficial={isAdmin}
                />
              </div>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {prependValue && (
                <div
                  style={{
                    fontSize: "0.85em",
                    color: "gray",
                    marginLeft: "4px",
                  }}
                >
                  {prependValue}
                </div>
              )}
              {!isReply && (
                <input
                  ref={subjectRef}
                  name="subject"
                  type="text"
                  placeholder={t("postForm.discussionBodyPlaceholder")}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="sentences"
                  spellCheck={false}
                  style={{
                    display: postType === "Discussion" ? "block" : "none",
                    width: "100%",
                    // outline: "none",
                    fontSize: "1em",
                    // fontWeight: "bold",
                    background: "transparent",
                    marginTop: "0.2em",
                    paddingTop: "1em",
                    marginBottom: "0.5em",
                    fontFamily: '"Poppins", sans-serif',
                    border: "1px solid #eeeeee",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                />
              )}
              {/* {!isReply && (
                <div style={{ marginBottom: "10px" }}>
                  <input
                    value={aiPrompt}
                    onChange={(e) => setAiPrompt(e.target.value)}
                    placeholder="Tell LoonLog AI what post to create..."
                    style={{
                      width: "100%",
                      border: "1px solid #eeeeee",
                      borderRadius: "10px",
                      padding: "10px",
                      marginBottom: "8px",
                      fontFamily: '"Poppins", sans-serif',
                    }}
                  />
                  
                  <button
                    type="button"
                    onClick={handleGenerateAiPost}
                    disabled={aiLoading}
                    className="post-form-footer-button"
                    style={{
                      border: "none",
                      cursor: aiLoading ? "not-allowed" : "pointer",
                      opacity: aiLoading ? 0.7 : 1,
                    }}
                  >
                    ✨ {aiLoading ? "Creating post..." : "Create Post with AI"}
                  </button>
                </div>
              )} */}
              <TextareaAutosize
                ref={bodyRef}
                minRows={4}
                maxRows={10}
                name="body"
                placeholder={
                  showRace
                    ? "LL Race"
                    : showPoll
                      ? t("postForm.pollPlaceholder")
                      : postType === "Discussion" && !isReply
                        ? t("postForm.discussionPlaceholder")
                        : t("postForm.placeholder")
                }
                autoFocus={!isReply && postType === "Post"}
                style={{
                  width: "100%",
                  resize: "none",
                  overflow: "auto",
                  // paddingTop: postType === "Discussion" ? "0" : "1em",
                  marginTop: postType === "Discussion" ? "0" : "0.2em",
                  letterSpacing: "normal",
                  border: "1px solid #eeeeee",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              />
            </div>
          </div>
          {processingImageLoading && <ProgressBar />}
          {error && (
            <div
              style={{
                color: "red",
                margin: "10px 0",
                padding: "10px",
                backgroundColor: "rgba(255,0,0,0.1)",
                borderRadius: "5px",
              }}
            >
              {error}
            </div>
          )}
          {showPoll && <PostPoll value={poll} onChange={(v) => setPoll(v)} />}
          {showRace && <PostRace value={race} onChange={(v) => setRace(v)} />}
          <div style={styles.media}>
            {exam && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "150px",
                    height: "auto",
                  }}
                >
                  <img src={ExamImageSrc} alt="exam" style={styles.preview} />
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.2em",
                  }}
                >
                  Interactive Exam Post
                  <br />
                  {new URLSearchParams(decodeURIComponent(exam)).get("id")}{" "}
                  {new URLSearchParams(decodeURIComponent(exam)).get("ch")}
                </div>
              </div>
            )}

            {previews.map((media, index) => (
              <div key={index} style={styles.previewWrapper}>
                <FaTimes style={styles.closeIcon} onClick={clearMediaInput} />
                {media.type.startsWith("video") ? (
                  <video
                    style={styles.preview}
                    playsInline
                    muted
                    loop
                    autoPlay
                    preload="metadata"
                  >
                    <source src={media.url} type={media.type} />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={media.url}
                    alt={`preview-${index}`}
                    style={styles.preview}
                  />
                )}
              </div>
            ))}
          </div>
          <div
            className="post-form-footer justify-content-sb"
            style={{ marginTop: "auto" }}
          >
            <ul
              className="display-flex flex-wrap-wrap justify-content-sb"
              style={{ width: "100%" }}
            >
              <li>
                <input
                  type="file"
                  id={inputId}
                  ref={fileInputRef}
                  multiple
                  // accept="image/*,video/*"
                  accept={onlyVideo ? "video/*" : "image/*,video/*"}
                  style={{ display: "none" }}
                  onChange={handleMediaChange}
                  title="Select up to 4 images or videos"
                />
                <label htmlFor={inputId} className="post-form-footer-button">
                  {/* <IonIcon icon={imageOutline} className="red-icon" /> */}
                  <span className="header-font">
                    {onlyVideo && "🎬 Upload or Record a LoonClip"}
                  </span>

                  {!onlyVideo && (
                    <>
                      <IonIcon icon={imageOutline} className="red-icon" />{" "}
                      <span style={{ fontWeight: "bold" }}> Media</span>
                    </>
                  )}

                  {/* <span className="header-font">{t("media")}</span> */}
                </label>
              </li>

              {/* <li>
                <label htmlFor="mediaInput" className="post-form-footer-button">
                  <IonIcon icon={videocamOutline} className="red-icon" />
                  <span className="header-font">{t("video")}</span>
                </label>
              </li> */}
              {!onlyVideo && (
                <>
                  <li>
                    <div
                      onClick={toggleShowPoll}
                      className="post-form-footer-button"
                    >
                      <IonIcon icon={pieChartOutline} className="red-icon" />
                      <span style={{ fontWeight: "bold" }}>{t("poll")}</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={toggleShowRace}
                      className="post-form-footer-button"
                    >
                      <IonIcon icon={barChartOutline} className="red-icon" />
                      <span style={{ fontWeight: "bold" }}>{t("race")}</span>
                    </div>
                  </li>
                </>
              )}
              {/* <li>
                <Popover
                  isOpen={emojiPickerOpen}
                  containerStyle={{
                    zIndex: 15,
                  }}
                  content={
                    <EmojiPicker
                      native
                      onEmojiClick={(_, emoji) =>
                        (bodyRef.current.value += emoji.emoji)
                      }
                    />
                  }
                  onClickOutside={() => setEmojiPickerOpen(false)}
                  positions={["top", "left", "right", "bottom"]}
                >
                  <div
                    onClick={() => setEmojiPickerOpen(!emojiPickerOpen)}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <IonIcon icon={happyOutline} className="red-icon" />
                  </div>
                </Popover>
              </li> */}

              {handleExamChange && !onlyVideo && (
                <li>
                  <SelectExam handleExamChange={handleExamChange} />
                </li>
              )}
            </ul>
          </div>
        </form>
      </Container>
    </>
  );
};

export default PostForm;
